/**
 * TRIL-669. When the analyzer is unavailable, `persistPublishAnalysis` fail-closes and
 * writes a NEUTRAL envelope — `overall_score: 50` with NO `plugin_results` — over the
 * client-forgeable blob (the TRIL-409/271 invariant). That envelope exists so URG has
 * something non-forgeable to read; it is NOT a real analysis, so every surface that
 * displays a score must show "unscored" rather than a bare 50.
 *
 * Absent/empty `plugin_results` is the only available discriminator: a genuine 50 from
 * a real analyzer run always carries plugin results.
 *
 * This module is the SINGLE implementation for all three tiers. It previously existed
 * as three hand-kept copies (server `isFailClosedAnalyzer`, client
 * `isFailClosedAnalysis`, mobile's private copy) under a comment claiming cross-tier
 * imports were impossible — they are not: `@trilirivos/story-text` is already a
 * `workspace:*` dependency of client, server AND mobile, and this package is plain,
 * dependency-free TypeScript consumed from `src/` by Vite, Metro, vitest and ts-node
 * alike.
 */
export function isFailClosedAnalysis(
	storyAnalyzer:
		| { overall_score?: number | null; plugin_results?: unknown }
		| null
		| undefined
		| unknown,
): boolean {
	if (!storyAnalyzer || typeof storyAnalyzer !== "object") return false;
	const pr = (storyAnalyzer as { plugin_results?: unknown }).plugin_results;
	if (pr === null || pr === undefined) return true;
	return typeof pr === "object" && Object.keys(pr as object).length === 0;
}
